<!-- 联系我们 -->
<template>
  <div class="contact">
    <img class="map" src="https://cdn.welove520.com/static/res/vue/playbay/map2.png">
    <div class="item_right">
      <div class="item">
        <img src="https://cdn.welove520.com/static/res/vue/playbay/address.png">
        <span class="title">公司地址</span>
        <span class="content">北京市海淀区善缘街1号5层1-523</span>
      </div>

      <div class="item">
        <img src="https://cdn.welove520.com/static/res/vue/playbay/cooperation.png">
        <span class="title">商务合作</span>
        <span class="content">bd@welove-inc.com</span>
      </div>

      <div class="item">
        <img src="https://cdn.welove520.com/static/res/vue/playbay/telephone.png">
        <span class="title">公司电话</span>
        <span class="content">010-82609308</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Contact",
  data() {
    return {};
  },
  created() {
    this.$store.dispatch("initTabName", "about");
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.contact {
  margin-top: 80px;
  margin-bottom: 190px;
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
}

.map {
  width: 270px;
}

.item_right {
  margin-left: 30px;
  display: flex;
  flex-flow: column nowrap;
  align-items: flex-start;
}

.item {
  margin-top: 35px;
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
}

.item > img {
  width: 20px;
}

.title {
  margin-left: 10px;
  font-size: 20px;
  color: #e1556d;
}

.content {
  margin-left: 18px;
  font-size: 18px;
  color: #303032;
  line-height: 34px;
}
</style>



// WEBPACK FOOTER //
// src/components/Contact.vue